module.exports = new __parcel__URL__("MMIRL4.b99fa7b6.jpg").toString();